import { Injectable } from '@angular/core';
import { SiterequestService } from 'src/app/core/services/siterequest.service';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, switchMap } from 'rxjs/operators';
import { IGetSiteRequestsResult } from 'src/app/feature/approvals/models/approvals';
import * as actions from './site-request.action';
import { of } from 'rxjs';

@Injectable()
export class SiteRequestEffects {

  constructor(private action: Actions, private siteRequestService: SiterequestService) { }

  $GetSiteApprovals = createEffect(() =>
    this.action.pipe(
      ofType(actions.GetSiteRequestsApiAction),
      switchMap(action => this.siteRequestService.getSiteRequestData().pipe(
        map((data: IGetSiteRequestsResult) => {
          return actions.SucessGetSiteRequestsApiAction({ data });
        }),
        catchError((error: Error) => {
          return of(actions.ErrorGetSiteRequestsApiAction(error));
        })
      ))
    )
  );
}
